import { ERequestStatus, IStatus } from '~/src/api/service-request/request-by-connection';

/**
 * Завяка уже созданна
 *
 * @name helpers.ALREADY_CREATED
 * @type {number}
 */
const ALREADY_CREATED = 0;

/**
 * Дом отсутствует в базе
 *
 * @name helpers.HOUSE_OUT_BASE
 * @type {number}
 */
const HOUSE_OUT_BASE = 6;

interface ISortable {
    sort: number | null | undefined
}

enum ESortResult {
    FIRST_PARAMETER_BEFORE = -1,
    EQUALS = 0,
    FIRST_PARAMETER_AFTER = 1,
}

export function sortFunction(first: ISortable, second: ISortable): ESortResult {
    if (first.sort === second.sort) {
        return ESortResult.EQUALS;
    }

    if (first.sort === null || first.sort === undefined) {
        return ESortResult.FIRST_PARAMETER_AFTER;
    }

    if (second.sort === null || second.sort === undefined) {
        return ESortResult.FIRST_PARAMETER_BEFORE;
    }

    if (first.sort < second.sort) {
        return ESortResult.FIRST_PARAMETER_BEFORE;
    } else if (first.sort > second.sort) {
        return ESortResult.FIRST_PARAMETER_AFTER;
    }

    return ESortResult.EQUALS;
}

/**
 * По биллинг коду возарвщает статус заявки
 *
 * @param {number} billingCode
 * @returns {{ status: string, ok: boolean}}
 */
export const getDataStatus = (billingCode: number): IStatus => {
    if (billingCode === ALREADY_CREATED || billingCode === HOUSE_OUT_BASE) {
        return { status : ERequestStatus.success, ok: true };
    }
    return { status : ERequestStatus.error, ok: false };
};
